var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "map-con" },
    [
      _c(
        "el-breadcrumb",
        { staticClass: "breadcrumb-con", attrs: { separator: "" } },
        [
          _c("el-breadcrumb-item", [
            _c("a", { on: { click: _vm.goback } }, [
              _c("i", { staticClass: "el-icon-arrow-left back-icon" })
            ])
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [
            _c(
              "div",
              { staticStyle: { color: "#fff", "font-weight": "600" } },
              [
                _vm._v(
                  _vm._s(
                    _vm.formatMessage({
                      id: "5g.message.h5.components.web",
                      defaultMessage: "网页"
                    })
                  )
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("iframe", {
        staticClass: "iframe-con",
        attrs: { src: _vm.webUrl, frameborder: "0", scrolling: "auto" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c5bb586", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c5bb586","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WebContainer.vue
// module id = null
// module chunks = 